module.exports = __webpack_public_path__ + "static/media/membership-monthly-sm.33e3f22a.png";